//  import React, { useState } from 'react';

// const MandatoryDisclosure = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);  // 🔥 Modal state

//   return (
//     <>
//       {/* 🔥 MAIN BUTTON */}
//       <div 
//         style={styles.mainButton}
//         onClick={() => setIsModalOpen(true)}  // 🔥 Modal open
//       >
//         📄 Mandatory Disclosure
//       </div>

//       {/* 🔥 FULLSCREEN PDF MODAL */}
//       {isModalOpen && (
//         <div style={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
//           <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//             <div style={styles.modalHeader}>
//               <h3>📄 Mandatory Disclosure</h3>
//               <span style={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</span>
//             </div>
            
//             <iframe
//               src="/MandatoryDisclosure.pdf#toolbar=0&navpanes=0&scrollbar=1"
//               style={styles.pdfFrame}
//               title="Mandatory Disclosure"
//             />
            
//             <div style={styles.modalFooter}>
//               <button style={styles.downloadBtn} onClick={() => window.open('/MandatoryDisclosure.pdf', '_blank')}>
//                 ⬇️ Download PDF
//               </button>
//               <button style={styles.closeBtnMobile} onClick={() => setIsModalOpen(false)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// const styles = {
//   mainButton: {
//     background: 'linear-gradient(135deg, rgb(0,111,47), #006f2f)',
//     color: '#fff',
//     padding: '8px 16px',
//     borderRadius: '20px',
//     cursor: 'pointer',
//     fontSize: '12px',
//     fontWeight: '600',
//     border: '1px solid rgba(255,255,255,0.3)',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     transition: 'all 0.3s ease',
//     whiteSpace: 'nowrap'
//   },
//   modalOverlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.95)',
//     zIndex: 10000,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px'
//   },
//   modalContent: {
//     width: '95%',
//     maxWidth: '1000px',
//     height: '90vh',
//     background: '#fff',
//     borderRadius: '12px',
//     overflow: 'hidden',
//     display: 'flex',
//     flexDirection: 'column'
//   },
//   modalHeader: {
//     padding: '20px 25px',
//     background: 'rgb(0,111,47)',
//     color: '#fff',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center'
//   },
//   closeBtn: {
//     fontSize: '24px',
//     cursor: 'pointer',
//     padding: '5px 10px',
//     borderRadius: '50%',
//     background: 'rgba(255,255,255,0.2)',
//     width: '40px',
//     height: '40px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.3s'
//   },
//   pdfFrame: {
//     flex: 1,
//     width: '100%',
//     border: 'none',
//     minHeight: '400px'
//   },
//   modalFooter: {
//     padding: '20px 25px',
//     display: 'flex',
//     gap: '15px',
//     justifyContent: 'center',
//     flexWrap: 'wrap'
//   },
//   downloadBtn: {
//     background: 'rgb(0,111,47)',
//     color: '#fff',
//     padding: '12px 30px',
//     border: 'none',
//     borderRadius: '25px',
//     fontWeight: '600',
//     fontSize: '16px',
//     cursor: 'pointer',
//     transition: 'all 0.3s'
//   },
//   closeBtnMobile: {
//     background: '#f8f9fa',
//     color: '#333',
//     padding: '12px 30px',
//     border: '2px solid #dee2e6',
//     borderRadius: '25px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s'
//   }
// };

// export default MandatoryDisclosure;
//   import React from "react";

// const PdfViewer = () => {
// return (
// <div style={{ width: "100%", height: "100vh" }}>
// <iframe
// src="/MandatoryDisclosure.pdf"
// title="PDF Viewer"
// width="100%"
// height="100%"
// style={{
// border: "none",
// marginTop:100
// }}
// /> </div>
// );
// };

// export default PdfViewer;
// import React from "react";

// const PdfViewer = () => {
// return ( <div style={styles.container}>

// ```
//   {/* 🔥 Header */}
//   <div style={styles.header}>
//     <h2 style={styles.title}>📄 Mandatory Disclosure</h2>

//     <a
//       href="/MandatoryDisclosure.pdf"
//       target="_blank"
//       rel="noopener noreferrer"
//       style={styles.downloadBtn}
//     >
//       ⬇ Download
//     </a>
//   </div>

//   {/* 🔥 PDF Viewer */}
//   <div style={styles.viewer}>
//     <iframe
//       src="/MandatoryDisclosure.pdf"
//       title="PDF Viewer"
//       style={styles.iframe}
//     />
//   </div>

// </div>
 

// );
// };

// const styles = {
// container: {
// width: "100%",
// height: "100vh", // ✅ IMPORTANT (minHeight hatao)
// display: "flex",
// flexDirection: "column",
// background: "#f5f6fa",
// marginTop:50
// },

// header: {
// height: "60px", // ✅ fixed height
// padding: "0 20px",
// background: "#1e293b",
// color: "#fff",
// display: "flex",
// justifyContent: "space-between",
// alignItems: "center",
// },

// title: {
// margin: 0,
// fontSize: "18px",
// },

// downloadBtn: {
// background: "#22c55e",
// color: "#fff",
// padding: "8px 14px",
// borderRadius: "6px",
// textDecoration: "none",
// fontSize: "14px",
// },

// viewer: {
// height: "calc(100vh - 60px)", // ✅ MAGIC LINE
// width: "100%",
// },

// iframe: {
// width: "100%",
// height: "100%",
// border: "none",
// },
// };

// export default PdfViewer;


// import React, { useEffect, useState } from "react";

// const PdfViewer = () => {
// const [isMobile, setIsMobile] = useState(false);

// useEffect(() => {
// const checkDevice = () => {
// setIsMobile(window.innerWidth <= 768);
// };

// ```
// checkDevice();
// window.addEventListener("resize", checkDevice);

// return () => window.removeEventListener("resize", checkDevice);
// ```

// }, []);

// // 🔥 Mobile → direct open PDF
// useEffect(() => {
// if (isMobile) {
// window.location.href = "/MandatoryDisclosure.pdf";
// }
// }, [isMobile]);

// return ( <div style={styles.container}>

// ```
//   {/* Header */}
//   <div style={styles.header}>
//     <h2 style={styles.title}>📄 Mandatory Disclosure</h2>

//     <a
//       href="/MandatoryDisclosure.pdf"
//       target="_blank"
//       rel="noopener noreferrer"
//       style={styles.downloadBtn}
//     >
//       ⬇ Download
//     </a>
//   </div>

//   {/* Desktop Viewer */}
//   {!isMobile && (
//     <div style={styles.viewer}>
//       <iframe
//         src="/MandatoryDisclosure.pdf#toolbar=0"
//         title="PDF Viewer"
//         style={styles.iframe}
//       />
//     </div>
//   )}

// </div>
 

// );
// };

// const styles = {
// container: {
// width: "100%",
// height: "100vh",
// display: "flex",
// flexDirection: "column",
// background: "#f8fafc",
// },

// header: {
// height: "60px",
// padding: "0 16px",
// background: "#0f172a",
// color: "#fff",
// display: "flex",
// justifyContent: "space-between",
// alignItems: "center",
// },

// title: {
// margin: 0,
// fontSize: "clamp(14px, 2vw, 18px)", // responsive text
// fontWeight: "600",
// },

// downloadBtn: {
// background: "#22c55e",
// color: "#fff",
// padding: "6px 12px",
// borderRadius: "6px",
// textDecoration: "none",
// fontSize: "clamp(12px, 2vw, 14px)",
// },

// viewer: {
// flex: 1,
// padding: "10px",
// },

// iframe: {
// width: "100%",
// height: "100%",
// border: "none",
// borderRadius: "8px",
// background: "#fff",
// },
// };

// export default PdfViewer;


// import React, { useEffect } from "react";

// const PdfViewer = () => {
//   const pdfUrl = "/MandatoryDisclosure.pdf";

//   useEffect(() => {
//     // 🔥 Mobile Check: Agar screen choti hai toh direct PDF open ho jaye
//     const isMobile = window.innerWidth <= 768;
//     if (isMobile) {
//       window.location.href = pdfUrl;
//     }
//   }, []);

//   return (
//     <div style={styles.container}>
//       {/* 🔹 Header Section */}
//       <div style={styles.header}>
//         <div style={styles.titleGroup}>
//           <span style={styles.icon}>📄</span>
//           <h2 style={styles.title}>Mandatory Disclosure</h2>
//         </div>

//         <a
//           href={pdfUrl}
//           target="_blank"
//           rel="noopener noreferrer"
//           style={styles.downloadBtn}
//           download
//         >
//           <span className="hide-mobile">Download PDF</span>
//           <span className="show-mobile">⬇</span>
//         </a>
//       </div>

//       {/* 🔹 PDF Viewer Section */}
//       <div style={styles.viewerContainer}>
//         <iframe
//           src={`${pdfUrl}#toolbar=0&navpanes=0`} // #toolbar=0 se extra buttons hat jayenge
//           title="PDF Viewer"
//           style={styles.iframe}
//         />
//       </div>

//       {/* 🔹 CSS-in-JS with Media Query Logic */}
//       <style>
//         {`
//           @media (max-width: 600px) {
//             .hide-mobile { display: none; }
//             .show-mobile { display: inline; }
//           }
//           @media (min-width: 601px) {
//             .show-mobile { display: none; }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     width: "100%",
//     height: "100vh",
//     display: "flex",
//     flexDirection: "column",
//     backgroundColor: "#f1f5f9", // Professional light grey
//     marginTop: "60px", // Navbar ke liye space
//   },
//   header: {
//     height: "65px",
//     padding: "0 5%",
//     background: "#1e293b", // Deep Navy Blue
//     color: "#ffffff",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//     zIndex: 10,
//   },
//   titleGroup: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },
//   icon: {
//     fontSize: "22px",
//   },
//   title: {
//     margin: 0,
//     fontSize: "1.1rem",
//     fontWeight: "600",
//     letterSpacing: "0.5px",
//   },
//   downloadBtn: {
//     background: "#2563eb", // Professional Blue
//     color: "#fff",
//     padding: "10px 20px",
//     borderRadius: "8px",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: "500",
//     transition: "0.3s",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
//   },
//   viewerContainer: {
//     flex: 1, // Baaki bachi poori screen le lega
//     width: "100%",
//     background: "#525659", // PDF viewer background color
//     display: "flex",
//     justifyContent: "center",
//   },
//   iframe: {
//     width: "100%",
//     height: "100%",
//     border: "none",
//     maxWidth: "1200px", // Desktop par bohot wide na ho
//   },
// };

// export default PdfViewer;

// import React, { useEffect } from "react";

// const PdfViewer = () => {
//   const pdfUrl = "/MandatoryDisclosure.pdf";

//   useEffect(() => {
//     // 🔥 Mobile Redirect Logic
//     const handleMobileView = () => {
//       if (window.innerWidth <= 768) {
//         // Direct PDF open karega mobile default viewer mein
//         window.location.replace(pdfUrl);
//       }
//     };

//     handleMobileView();
//     window.addEventListener("resize", handleMobileView);
//     return () => window.removeEventListener("resize", handleMobileView);
//   }, [pdfUrl]);

//   return (
//     <div style={styles.container}>
//       {/* 🔹 Header Section */}
//       <div style={styles.header}>
//         <div style={styles.titleGroup}>
//           <span style={styles.icon}>📄</span>
//           <h2 style={styles.title}>
//             <span className="hide-mobile">Mandatory</span> Disclosure
//           </h2>
//         </div>

//         <a
//           href={pdfUrl}
//           target="_blank"
//           rel="noopener noreferrer"
//           style={styles.downloadBtn}
//           download
//         >
//           <span className="hide-mobile">Download Document</span>
//           <span className="show-mobile">Download</span>
//           <span style={{ marginLeft: "5px" }}>⬇</span>
//         </a>
//       </div>

//       {/* 🔹 PDF Viewer Section */}
//       <div style={styles.viewerContainer}>
//         <iframe
//           src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
//           title="PDF Viewer"
//           style={styles.iframe}
//         />
//       </div>

//       {/* 🔹 Responsive CSS Rules */}
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .hide-mobile { display: none !important; }
//             .show-mobile { display: inline !important; }
//           }
//           @media (min-width: 769px) {
//             .show-mobile { display: none !important; }
//           }
          
//           /* Smooth transition for buttons */
//           a:hover {
//             background-color: #1d4ed8 !important;
//             transform: translateY(-1px);
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     width: "100%",
//     height: "100vh",
//     display: "flex",
//     flexDirection: "column",
//     backgroundColor: "#f8fafc",
//     overflow: "hidden", // Extra scrollbar nahi aayegi
//   },
//   header: {
//     height: "70px",
//     padding: "0 24px",
//     background: "#1e293b",
//     color: "#ffffff",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
//     zIndex: 100,
//   },
//   titleGroup: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//   },
//   icon: {
//     fontSize: "24px",
//   },
//   title: {
//     margin: 0,
//     fontSize: "clamp(14px, 4vw, 18px)", // 🔥 Responsive font size
//     fontWeight: "600",
//     color: "#f1f5f9",
//   },
//   downloadBtn: {
//     background: "#2563eb",
//     color: "#fff",
//     padding: "10px 18px",
//     borderRadius: "8px",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     transition: "all 0.2s ease",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//   },
//   viewerContainer: {
//     flex: 1,
//     width: "100%",
//     background: "#334155",
//     display: "flex",
//     justifyContent: "center",
//     padding: "10px", // Desktop par thoda gap acha lagta hai
//   },
//   iframe: {
//     width: "100%",
//     height: "100%",
//     border: "none",
//     borderRadius: "4px",
//     maxWidth: "1100px", // Center align rakhne ke liye
//     backgroundColor: "#fff",
//   },
// };

// export default PdfViewer;
//  import React, { useEffect, useState, useCallback } from "react";

// const PdfViewer = () => {
//   const pdfUrl = "/MandatoryDisclosure.pdf";
//   const [isMobile, setIsMobile] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);

//   const checkDevice = useCallback(() => {
//     const width = window.innerWidth;
//     const mobile = width <= 768;
//     setIsMobile(mobile);
    
//     if (mobile && isLoaded) {
//       window.location.replace(pdfUrl);
//       return true;
//     }
//     return false;
//   }, [pdfUrl, isLoaded]);

//   useEffect(() => {
//     const handleLoad = () => {
//       setIsLoaded(true);
//       checkDevice();
//     };

//     if (document.readyState === 'complete') {
//       handleLoad();
//     } else {
//       window.addEventListener('load', handleLoad);
//     }

//     window.addEventListener("resize", checkDevice);
    
//     return () => {
//       window.removeEventListener('load', handleLoad);
//       window.removeEventListener("resize", checkDevice);
//     };
//   }, [checkDevice]);

//   if (isMobile && isLoaded) {
//     return null;
//   }

//   return (
//     <div style={styles.mainContainer}>
     

//       {/* 🔥 PDF Viewer Section */}
//       <main style={styles.viewerSection}>
//         <div style={styles.viewerCard}>
//           <iframe
//             src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
//             title="Mandatory Disclosure PDF"
//             style={styles.iframe}
//             loading="lazy"
//           />
//         </div>
//       </main>

//       <style jsx>{`
//         @media (max-width: 768px) {
//           body, html, #root { 
//             display: none !important; 
//             visibility: hidden !important; 
//           }
//         }
//         @media (min-width: 769px) {
//           body, html, #root { 
//             display: block !important; 
//             visibility: visible !important; 
//           }
//         }
        
//         /* Smooth animations */
//         * {
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//         }
        
//         a:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 20px 40px rgba(37, 99, 235, 0.4);
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   mainContainer: {
//     width: "100vw",
//     height: "100vh",
//     margin: 0,
//     padding: 0,
//     overflow: "hidden",
//     background: "linear-gradient(145deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   },
  
//   // Header - Professional Design
//   header: {
//     position: "sticky",
//     top: 0,
//     width: "100%",
//     height: "80px",
//     background: "linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%)",
//     backdropFilter: "blur(20px)",
//     WebkitBackdropFilter: "blur(20px)",
//     boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
//     zIndex: 1000,
//     borderBottom: "1px solid rgba(255,255,255,0.1)",
//   },
  
//   headerContent: {
//     maxWidth: "1400px",
//     height: "100%",
//     margin: "0 auto",
//     padding: "0 32px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },
  
//   logoSection: {
//     display: "flex",
//     alignItems: "center",
//     gap: "20px",
//   },
  
//   logoIcon: {
//     width: "48px",
//     height: "48px",
//     borderRadius: "16px",
//     background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "24px",
//     boxShadow: "0 8px 25px rgba(59, 130, 246, 0.4)",
//     color: "white",
//   },
  
//   titleSection: {
//     color: "white",
//   },
  
//   mainTitle: {
//     margin: "0 0 4px 0",
//     fontSize: "28px",
//     fontWeight: 700,
//     letterSpacing: "-0.02em",
//     lineHeight: 1.2,
//   },
  
//   subtitle: {
//     margin: 0,
//     fontSize: "16px",
//     opacity: 0.9,
//     fontWeight: 400,
//   },
  
//   downloadButton: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "14px 28px",
//     background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//     color: "white",
//     textDecoration: "none",
//     borderRadius: "16px",
//     fontSize: "16px",
//     fontWeight: 600,
//     boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//     border: "1px solid rgba(255,255,255,0.2)",
//     backdropFilter: "blur(10px)",
//     minHeight: "52px",
//   },
  
//   downloadText: {
//     fontWeight: 600,
//     letterSpacing: "-0.01em",
//   },
  
//   downloadIcon: {
//     width: "20px",
//     height: "20px",
//     color: "white",
//     flexShrink: 0,
//   },
  
//   // Viewer Section
//   viewerSection: {
//     flex: 1,
//     width: "100%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "40px 20px",
//     background: "rgba(241, 245, 249, 0.8)",
//     backdropFilter: "blur(10px)",
//   },
  
//   viewerCard: {
//     width: "100%",
//     maxWidth: "1400px",
//     height: "calc(125vh - 140px)",
//     maxHeight: "100vh",
//     background: "white",
    
//     boxShadow: "0 25px 80px rgba(0,0,0,0.2)",
//     overflow: "hidden",
//     border: "1px solid rgba(255,255,255,0.3)",
//     backdropFilter: "blur(20px)",
//   },
  
//   iframe: {
//     width: "100%",
//     height: "100%",
//     border: "none",
//     borderRadius: "24px",
//     background: "white",
//     display: "block",
//   },
// };

// export default PdfViewer;

import React from "react";

const PdfViewer = () => {
  const pdfUrl = "/MandatoryDisclosure.pdf";

  return (
    <div style={styles.container}>
      
      {/* Header */}
      {/* <div style={styles.header}>
        <h2 style={styles.title}>📄 Mandatory Disclosure</h2>

        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.downloadBtn}
        >
          ⬇ Download
        </a>
      </div> */}

      {/* PDF Viewer */}
      <iframe
        src={pdfUrl}
        title="PDF"
        style={styles.iframe}
      />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#f8fafc",
  },

  header: {
    height: "60px",
    background: "#1e293b",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 15px",
  },

  title: {
    margin: 0,
    fontSize: "16px",
  },

  downloadBtn: {
    background: "#3b82f6",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "13px",
  },

  iframe: {
    flex: 1,
    width: "100%",
    border: "none",
  },
};

export default PdfViewer;